import axiosInstance from '../axiosInterceptor/axiosInstance'

const getSeasonTeamPlayers = async (orgId, seasonTeamId) => {
  const url = `v1/orgs/${orgId}/season-team-players?seasonTeamId=${seasonTeamId}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getSeasonTeamPlayers
